import {
    addOWAConnectedAccount,
    removeOWAConnectedAccount,
    updateOWAConnectedAccountToken,
    updateOWAConnectedAccountStatus,
} from '../actions';
import { mutator } from 'satcheljs';
import getStore from '../store';
import { addSeconds, now } from 'owa-datetime';

mutator(addOWAConnectedAccount, ({ account }) => {
    getStore().accountsMap.set(account.primarySmtpAddress, account);
});

mutator(removeOWAConnectedAccount, ({ primarySmtpAddress: primarySmtpAddress }) => {
    getStore().accountsMap.delete(primarySmtpAddress);
});

mutator(
    updateOWAConnectedAccountToken,
    ({
        primarySmtpAddress: primarySmtpAddress,
        accountToken: accountToken,
        accountTokenExpiresIn: accountTokenExpiresIn,
    }) => {
        const connectedAccount = getStore().accountsMap.get(primarySmtpAddress);
        connectedAccount.token = accountToken;
        connectedAccount.tokenExpiry = addSeconds(now(), parseInt(accountTokenExpiresIn));
    }
);

mutator(
    updateOWAConnectedAccountStatus,
    ({ primarySmtpAddress: primarySmtpAddress, isAccountValid: isAccountValid }) => {
        const connectedAccount = getStore().accountsMap.get(primarySmtpAddress);
        connectedAccount.isAccountValid = isAccountValid;
    }
);
